import { useHttpQuery } from '@luminovo/data-stack';

export type MagicBellIdentity = {
    externalId: string;
    // MagicBell authenticates the user with it: https://www.magicbell.com/docs/turn-on-hmac-authentication
    hmac: string;
};

/** The user's MagicBell HMAC identity; `isUnavailable` (no API key or request failed) means it will never load. */
export function useMagicBellIdentity(): { identity: MagicBellIdentity | undefined; isUnavailable: boolean } {
    const { data, isError } = useHttpQuery('GET /my/magicbell', {}, { select: (res) => res.data, staleTime: Infinity });
    if (!window.MAGIC_BELL_API_KEY || isError) {
        return { identity: undefined, isUnavailable: true };
    }
    if (!data) {
        return { identity: undefined, isUnavailable: false };
    }
    return { identity: { externalId: data.external_id, hmac: data.hmac }, isUnavailable: false };
}
